import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SubHeader = () => {
	const [subHed, setSubHed] = useState(true);
	useEffect(() => {
		let lastScrollTop = 0;
		const handle = () => {
			let scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop > lastScrollTop) {
				setSubHed(false);
			} else {
				setSubHed(true);
			}
			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
		};
		window.addEventListener("scroll", handle);
		return () => window.removeEventListener("scroll", handle);
	}, []);
	return (
		<div
			className={
				subHed
					? "shadow-lg h-12 w-full bg-white flex justify-between items-center p-4 text-lg sticky z-40 top-20 transition-all"
					: "shadow-lg h-12 w-full bg-white flex justify-between items-center p-4 text-lg sticky z-40 top-8 transition-all"
			}
		>
			<Link to="/">
				<i className="fa-solid fa-house text-orange-600 cursor-pointer"></i>
			</Link>
			<i className="fa-solid fa-magnifying-glass text-orange-600 cursor-pointer"></i>
		</div>
	);
};

export default SubHeader;
